var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.profile_picture)?_c('img',{staticClass:"img-profile",attrs:{"src":_vm.user.profile_picture,"alt":_vm.user.name}}):_c('img',{staticClass:"img-profile",attrs:{"src":require("../assets/img/default-picture.jpg"),"alt":_vm.user.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }